import './style.scss';
import 'ShopUiBundle/components/atoms/form-check';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('form-check-group', () => import(/* webpackMode: "lazy" */'./form-check-group'));
